import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import { BannerMobileDetailProps, BannerUrlHelperText, BannerBodyConstants, BannerTitleConstants, BannerUrlConstants } from "./constants";


const BannerMobileDetail: React.FC<BannerMobileDetailProps> = ({ Culture }) => {
	const { bannerMobileForm, setBannerMobileForm } = useBannerMobileContext();
	const localizable = bannerMobileForm?.bannerMobileLocalizable?.find(item => item.culture === Culture);

	const handleLocalizableChange = (field: string, value: string) => {
		const updatedLocalizable = [...bannerMobileForm.bannerMobileLocalizable];
		const index = updatedLocalizable.findIndex(item => item.culture === Culture);
		if (index !== -1) {
			updatedLocalizable[index] = {
				...updatedLocalizable[index],
				[field]: value
			};
		}
		setBannerMobileForm(prevState => ({
			...prevState,
			bannerMobileLocalizable: updatedLocalizable
		}));
	};

	return (
		<>
			{localizable && (
				<div key={localizable.culture}>
					<Row gutter={20}>
						<Col span={20}>
							<InputComponent
								title={BannerTitleConstants[Culture].title}
								placeholder={BannerTitleConstants[Culture].placeholder}
								value={localizable.firstHeader}
								isRequired
								onChange={(e) => handleLocalizableChange("firstHeader", e.target.value)}
							/>
						</Col>
					</Row>
					<Row gutter={20}>
						<Col span={20}>
							<TextareaComponent
								title={BannerBodyConstants[Culture].body}
								placeholder={BannerBodyConstants[Culture].placeholder}
								resizable={false}
								value={localizable.header}
								isRequired
								onChange={(e) => handleLocalizableChange("header", e.target.value)}
								rows={8}
							/>
						</Col>
					</Row>
					{bannerMobileForm.hasNavigation && (
						<Row gutter={20} style={{ marginTop: 10 }}>
							<Col span={20}>
								<InputComponent
									title={BannerUrlConstants[Culture].url}
									helperText={BannerUrlHelperText}
									placeholder={BannerUrlConstants[Culture].placeholder}
									value={localizable.url}
									onChange={(e) => handleLocalizableChange("url", e.target.value)}
								/>
							</Col>
						</Row>
					)}
				</div>
			)}
		</>
	);
};

export default BannerMobileDetail;
